<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzTitle="Página Inicial" nzSubtitle=" - Seja bem-vindo.">
    </nz-page-header>
</div>

<nz-row [nzGutter]="[14, 14]">
    <nz-col [nzSpan]="8">
        <nz-skeleton size="small" [nzLoading]="loadingQtdPesquisas" [nzParagraph]="{ rows: 1 }" nzActive="true">
        </nz-skeleton>
        <nz-card *ngIf="!loadingQtdPesquisas">
            <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdPesquisas" nzTitle="Pesquisas Realizadas Hoje">
            </nz-statistic>
            <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'dd/MM/yyyy HH:mm:ss'}}</small>
        </nz-card>

    </nz-col>

    <nz-col [nzSpan]="8">
        <nz-skeleton size="small" [nzLoading]="loadingQtdPesquisas" [nzParagraph]="{ rows: 1 }" nzActive="true">
        </nz-skeleton>
        <nz-card *ngIf="!loadingQtdPesquisas">
            <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdPesquisasMes" nzTitle="Qtd. Pesquisas do Mês">
            </nz-statistic>
            <small style="float: left; margin-top: 10px;"><a (click)="openHistoricoPesquisasMensal()"><i nz-icon nzType="plus" nzTheme="outline"></i> Ver Histórico</a></small>
            <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'MM/yyyy'}}</small>
        </nz-card>

    </nz-col>
    <nz-col [nzSpan]="8">
        <nz-skeleton size="small" [nzLoading]="loadingQtdMedicamentos" [nzParagraph]="{ rows: 1 }" nzActive="true">
        </nz-skeleton>
        <nz-card *ngIf="!loadingQtdPesquisas">
            <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdMedicamentos" nzTitle="Medicamentos Cadastrados">
            </nz-statistic>
            <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'dd/MM/yyyy HH:mm:ss'}}</small>
        </nz-card>

    </nz-col>
    <nz-col [nzSpan]="12">
        <nz-skeleton size="small" [nzLoading]="loadingTotalLeads" [nzParagraph]="{ rows: 1 }" nzActive="true">
        </nz-skeleton>
        <nz-card *ngIf="!loadingTotalLeads">
            <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdTotalLeads" nzTitle="Total de Leads Cadastrados">
            </nz-statistic>
            <small style="float: left; margin-top: 10px;"><a (click)="openHistoricoTotalLeads()"><i nz-icon nzType="plus" nzTheme="outline"></i> Ver Histórico</a></small>
            <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'MM/yyyy'}}</small>
        </nz-card>

    </nz-col>
    <nz-col [nzSpan]="12">
        <nz-skeleton size="small" [nzLoading]="loadingNovosLeads" [nzParagraph]="{ rows: 1 }" nzActive="true">
        </nz-skeleton>
        <nz-card *ngIf="!loadingNovosLeads">
            <nz-statistic [nzValueStyle]="{ color: '#3F8600' }" [nzValue]="qtdNovosLeads" nzTitle="Novos Leads">
            </nz-statistic>
            <small style="float: left; margin-top: 10px;"><a (click)="openHistoricoNovosLeads()"><i nz-icon nzType="plus" nzTheme="outline"></i> Ver Histórico</a></small>
            <small style="float: right; margin-top: 10px;"><i nz-icon nzType="calendar" nzTheme="outline"></i> {{dataAtual | date: 'MM/yyyy'}}</small>
        </nz-card>

    </nz-col>
</nz-row>

<nz-modal [(nzVisible)]="isVisibleHistorico" nzCentered="true" [nzFooter]="null" [nzTitle]="'Histórico de Pesquisas Mensais'" (nzOnCancel)="closeHistorico()" nzWidth="600px">
    <ng-container *nzModalContent>
    <app-chart-historico-pesquisas-mensal></app-chart-historico-pesquisas-mensal>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isVisibleHistoricoNovosLeads" nzCentered="true" [nzFooter]="null" [nzTitle]="'Histórico de Novos Leads'" (nzOnCancel)="closeHistoricoNovosLeads()" nzWidth="600px">
    <ng-container *nzModalContent>
    <app-chart-historico-novos-leads></app-chart-historico-novos-leads>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isVisibleHistoricoTotalLeads" nzCentered="true" [nzFooter]="null" [nzTitle]="'Histórico de Total de Leads Cadastrados'" (nzOnCancel)="closeHistoricoTotalLeads()" nzWidth="600px">
    <ng-container *nzModalContent>
    <app-chart-historico-total-leads></app-chart-historico-total-leads>
    </ng-container>
</nz-modal>